// How the activity history reads (praiseboard__events.event_type -> a sentence).
const TEXT = {
  consent_given: 'New feedback, with permission to publish',
  private_feedback: 'New private feedback',
  read: 'Opened',
  approved: 'Approved',
  client_requested: 'Sent to the client for approval',
  published: 'Published',
  unpublished: 'Unpublished',
  archived: 'Archived',
  restored: 'Restored',
  marked_spam: 'Marked as spam',
  not_spam: 'Moved out of spam',
  marked_private: 'Kept private by the business',
  quote_edited: 'Quote updated',
  note_added: 'Private note added',
  imported: 'Imported',
  withdrawn: 'The customer withdrew permission',
  details_hidden: 'The customer hid their name, job title, company and photo',
  removal_requested: 'Removal requested from the hosted wall',
  removal_resolved: 'Removal request resolved',
  first_published: 'First testimonial live',
  workspace_created: 'Workspace created',
  workspace_logo_changed: 'Workspace logo changed',
  brand_created: 'Brand added',
  brand_updated: 'Brand details updated',
  brand_archived: 'Brand archived',
  brand_restored: 'Brand restored',
  brand_logo_changed: 'Brand logo changed',
  client_approval_on: 'Client approval switched on',
  client_approval_off: 'Client approval switched off',
  form_created: 'Collection page created',
  form_updated: 'Collection page edited',
  form_active: 'Collection page turned on',
  form_paused: 'Collection page paused',
  form_archived: 'Collection page archived',
  widget_created: 'Widget created',
  widget_updated: 'Widget updated',
  widget_deleted: 'Widget deleted',
  wall_live: 'Hosted wall went live',
  wall_paused: 'Hosted wall paused',
  wall_draft: 'Hosted wall set to draft',
  reviewer_added: 'Client reviewer added',
  reviewer_link_rotated: 'Client review link replaced',
  reviewer_revoked: 'Client reviewer removed',
  report_link_created: 'Client report link created',
  report_link_revoked: 'Client report link revoked',
  template_saved: 'Template saved',
  member_invited: 'Teammate invited',
  member_joined: 'Teammate joined',
  member_changed: 'Teammate access changed',
  member_removed: 'Teammate removed',
  member_left: 'Teammate left',
  admin_paused: 'Public pages paused by an administrator',
  admin_unpaused: 'Public pages resumed by an administrator'
};

export function describeEvent(event) {
  if (event.type === 'client_review') {
    return (event.metadata && event.metadata.decision === 'approved') ? 'The client approved it' : 'The client asked for changes';
  }
  if (event.type === 'quote_edited' && event.metadata) {
    return event.metadata.shortened ? 'Quote shortened' : 'Quote set to the full answer';
  }
  return TEXT[event.type] || event.type.replace(/_/g, ' ');
}

export function actorOf(event) {
  if (event.actor_type === 'customer') return 'Customer';
  if (event.actor_type === 'client_reviewer') return (event.actor || 'Client') + ' (client)';
  if (event.actor_type === 'system') return event.actor || 'TrustClap';
  return event.actor || 'A teammate';
}
